import React, { useState, useEffect } from "react";
import { FaPlay, FaStop } from "react-icons/fa";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import "./Chatwindow.css";

const ChatWindow = ({ messages, isApiInProgress }) => {
  const [loadingMessageId, setLoadingMessageId] = useState(null);
  const [playingMessageId, setPlayingMessageId] = useState(null);
  const [voices, setVoices] = useState([]);
  const [selectedVoice, setSelectedVoice] = useState(null);

  useEffect(() => {
    const synth = window.speechSynthesis;
    const populateVoices = () => {
      const availableVoices = synth.getVoices();
      console.log(availableVoices);

      setVoices(availableVoices);
      if (availableVoices.length > 0) {
        setSelectedVoice(availableVoices[2]); // Default to the first available voice
      }
    };

    populateVoices();
    synth.onvoiceschanged = populateVoices;
  }, []);

  useEffect(() => {
    const fetchApiData = async () => {
      setLoadingMessageId(null);
      scrollToBottom();
    };

    if (loadingMessageId !== null) {
      fetchApiData();
    }
  }, [loadingMessageId]);

  const scrollToBottom = () => {
    const chatWindow = document.getElementById("chat-window");
    if (chatWindow) {
      chatWindow.scrollTop = chatWindow.scrollHeight;
    }
  };

  useEffect(() => {
    if (messages.length > 0 && messages[messages.length - 1].isUser) {
      setLoadingMessageId(messages.length);
    }
  }, [messages]);

  const speakText = (text, index) => {
    const synth = window.speechSynthesis;
    const utterance = new SpeechSynthesisUtterance(text);

    // Set the selected voice
    if (selectedVoice) {
      utterance.voice = selectedVoice;
    }

    // Customize speech properties
    utterance.pitch = 1; // Default pitch (range 0-2)
    utterance.rate = 1; // Default rate (range 0.1-10)
    utterance.volume = 0.5; // Default volume (range 0-1)

    synth.speak(utterance);
    utterance.onend = () => {
      setPlayingMessageId(null);
    };
  };

  const stopText = () => {
    const synth = window.speechSynthesis;
    if (synth.speaking) {
      synth.cancel();
    }
    setPlayingMessageId(null);
  };

  const handlePlayClick = (text, index) => {
    if (playingMessageId !== index) {
      stopText();
      speakText(text, index);
      setPlayingMessageId(index);
    } else {
      stopText();
    }
  };

  const renderMessageContent = (text, index) => {
    const urlRegex = /(https?:\/\/[^\s]+)/g;

    const components = {
      table: ({ children }) => <table className="table">{children}</table>,
      tr: ({ children }) => <tr>{children}</tr>,
      td: ({ children }) => <td>{children}</td>,
      a: ({ node, ...props }) => (
        <a
          {...props}
          href={props.href}
          target="_blank"
          rel="noopener noreferrer"
        >
          {props.children}
        </a>
      ),
    };

    const textWithLinks = text
      .split(urlRegex)
      .map((part, index) => {
        if (part.match(urlRegex)) {
          return `[${part}](${part})`;
        }
        return part;
      })
      .join("");

    return (
      <ReactMarkdown remarkPlugins={[remarkGfm]} components={components}>
        {textWithLinks}
      </ReactMarkdown>
    );
  };

  return (
    <div
      id="chat-window"
      className="container chat-window border p-3 mb-3 bg-white"
      style={{ overflowY: "auto" }}
    >
      {messages.map((msg, index) => (
        <div
          key={index}
          className={`message-container ${msg.isUser ? "user" : "bot"}`}
        >
          {!msg.isUser ? (
            <>
              {playingMessageId === index ? (
                <FaStop className="response-icon" onClick={stopText} />
              ) : (
                <FaPlay
                  className="response-icon"
                  onClick={() => handlePlayClick(msg.text, index)}
                />
              )}
              <div
                className={`message bot-message ${
                  loadingMessageId === index ? "blinking-label" : ""
                }`}
              >
                {loadingMessageId === index
                  ? "Loading..."
                  : renderMessageContent(msg.text, index)}
              </div>
            </>
          ) : (
            <div className={`message user-message`}>{msg.text}</div>
          )}
        </div>
      ))}
      {isApiInProgress && (
        <div className="message-container bot">
          <div className="message bot-message blinking-label">Loading...</div>
        </div>
      )}
      {isApiInProgress && <div className="modal-backdrop fade show"></div>}
      {isApiInProgress && (
        <div className="position-absolute top-30 start-50 translate-middle w-100 h-100 d-flex justify-content-center align-items-center bg-white bg-opacity-50">
          <div className="spinner-border text-primary" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default ChatWindow;
